<template>
  <div>
    <VTableLocal
      v-if="team.teamType !== 'client' && clientsAndSites"
      :iconHeader="hasPermission('members.clients.add') ? 'add' : null"
      :items="clientsAndSites.clients || []"
      :itemActions="btnAction"
      :centerColumns="['action']"
      isSearchable
      showExpand
      :headers="tableHeaders"
      :title="$t('clients.clientsAccess')"
      @iconAction="onClickConfirmRemove"
      @click-icon-header="onClickShowModal"
    >
      <template #expanded-item="props">
        <td :colspan="props.headers.length">
          <VTableLocal
            :items="props.item.sites || []"
            disablePagination
            :headers="siteHeader"
          >
            <template
              v-slot:item="{ item }"
            >
              <VCheckbox
                v-model="item.hasAccess"
                :disabled="!hasPermission('members.clients.add')"
                :label="item.name"
                @change="revokeSiteToMember(item.hasAccess,item.id)"
              />
            </template>
          </VTableLocal>
        </td>
      </template>
    </VTableLocal>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import AssociateClientForm from '@/components/team/AssociateClientForm';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';

export default {
    components: {
        VTableLocal,
    },
    data() {
        return {
            clientsAndSites: [],
            hasAccess: false,
        };
    },
    computed: {
        ...mapGetters([
            'member',
            'team',
            'hasPermission',
        ]),
        btnAction() {
            if (this.hasPermission('members.clients.remove')) {
                return [{
                    name: this.$t('forms.btn.delete'),
                    icon: 'delete',
                    mode: 'delete',
                    iconAndTextColor: '#EF4135',
                }];
            }
            return [];
        },
        tableHeaders() {
            return [
                'name',
                'accountNumber',
            ].map(header => ({
                text: this.$t(`forms.labels.${header}`),
                value: header,
            }));
        },
        siteHeader() {
            return [
                'name',
            ].map(header => ({
                text: this.$t(`forms.labels.${header}`),
                value: header,
            }));
        },
    },
    created() {
        this.getMemberClients();
    },
    methods: {
        onClickShowModal(item) {
            if (item === 'add') {
                this.showAssociateClientModal();
            } else {
                this.showRevokeClientModal(item);
            }
        },
        showAssociateClientModal() {
            this.$root.$emit('showModal', {
                title: this.$t('members.associateClient'),
                component: Vue.component('associateClientForm', AssociateClientForm),
                onConfirm: requestPayload => this.associateMemberRequest(requestPayload),
            });
        },
        onClickConfirmRemove(item) {
            this.$root.$emit('showModal', {
                title: this.$t('members.revokeClient'),
                component: Vue.component('revokeForm', ConfirmForm),
                payload: {
                    msg: this.$t('members.confirmRevoke', {
                        client: `${item.name} [${item.accountNumber}]`,
                        member: `${this.member.firstName} ${this.member.lastName}`,
                    }),
                },
                onConfirm: () => this.revokeClientToMember(item),
                isForm: false,
            });
        },
        async associateMemberRequest(requestPayload) {
            const client = { clientId: requestPayload.id };
            const { id, firstName, lastName } = this.member;

            await this.$rq.associateMemberToClient(id, client);
            this.$toasted.global.toast_success({
                message: this.$t('msg.clientAssociated', {
                    client: requestPayload.name,
                    member: `${firstName} ${lastName}`,
                }),
            });
            this.getMemberClients();
        },
        async revokeClientToMember(client) {
            const { id: clientId, name, accountNumber } = client;
            const { id: memberId, firstName, lastName } = this.member;

            await this.$rq.revokeClientToMember(memberId, clientId);

            this.$toasted.global.toast_success({
                message: this.$t('msg.memberRevoked', {
                    client: `${name} [${accountNumber}]`,
                    member: `${firstName} ${lastName}`,
                }),
            });
            this.getMemberClients();
        },
        async getMemberClients() {
            const { data } = await this.$rq.getMemberAccess(this.member.id);
            this.clientsAndSites = data;
            this.$emit('canAllAccessClients', data.canAllAccessClients);
        },
        async revokeSiteToMember(hasAccess, siteId) {
            if (!hasAccess) {
                await this.$rq.revokeSiteToMember(this.member.id, siteId);
                return false;
            }
            await this.$rq.associateMemberToSite(this.member.id, { siteId });
            return true;
        },
    },
};
</script>
